<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile ">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <!-----------------DROPDOWN DE ORGANIZAÇÃO-------------------------->
                <Dropdown v-model="organizationSelected" :options="orgsList"
                          @change="handleOrganizationChange($event.value)"
                          optionLabel="display_name" :placeholder="$t('AppApontamentos.Selecione a organização')"
                          class="auto-center dropdown-width" :dataKey="'id'"
                          :filter="true">
                    <template #option="slotProps">
                        <div>
                            <div v-if="loadingOrgs">{{ $t('AppApontamentos.Carregando, aguarde') }}</div>
                            <div v-else-if="slotProps.option.display_name === 'ND'">
                                -
                            </div>
                            <div v-else>
                                {{ slotProps.option.display_name }}
                            </div>
                        </div>
                    </template>
                </Dropdown>

                <div class="kt-portlet__head-label">
                        <span class="kt-portlet__head-icon">
                        </span>
                </div>
                <div class="kt-portlet__head-toolbar ">
                    <div class="kt-portlet__head-wrapper">
                        <app-button type="secondary" @handleClick="back"
                                    :class="{'margin-25-right': !is_col_12, 'width-button': is_col_12}">
                            <i class="glyphicons glyphicons-arrow-left"></i><span v-if="!is_col_12">{{ $t('AppApontamentos.Voltar') }}</span>
                        </app-button>
                    </div>
                </div>
            </div>
            <!-----------------CORPO DA PÁGINA-------------------------->
            <div v-if="!organizationSelected" class="apontamentos-body">
                <h3>
                    {{ $t('AppApontamentos.Selecione uma organização para visualizar os apontamentos') }}
                </h3>
            </div>
            <div v-else class="apontamentos-body">
                <div class="apontamentos-list white-background">
                    <div class="apontamentos-list_title">
                        <h3 style="margin: 0rem">{{ $t('AppApontamentos.Lista de Apontamentos') }}</h3>
                        <app-button type="primary" @handleClick='openDialog("import")'>
                            <span class="pi pi-arrow-up-right mr-2"/>
                           {{ $t('AppApontamentos.Importar Apontamentos') }}
                        </app-button>
                    </div>

                    <div class="apontamentos-list_table">
                        <div v-if="apontamentosList != null" style="width: 100%;">
                            <DataTable :value="apontamentosList" :rowHover="true"
                                       :loading="apontamentosLoading" responsiveLayout="scroll">
                                <template #loading>
                                    {{ $t('AppApontamentos.Carregando apontamentos, por favor aguarde') }}
                                </template>
                                <Column field="code" :header="$t('AppApontamentos.Código')" headerClass="headerClass"
                                        bodyClass="bodyClass">
                                    <template #body="slotProps">
                                        <h5>{{ slotProps.data.code }}</h5>
                                    </template>
                                </Column>
                                <Column field="description" :header="$t('AppApontamentos.Descrição')"
                                        headerClass="headerClass" bodyClass="bodyClass">
                                    <template #body="slotProps">
                                        <h5>{{ slotProps.data.description }}</h5>
                                    </template>
                                </Column>
                                <Column field="type" :header="$t('AppApontamentos.Tipo de Parada')"
                                        headerClass="headerClass" bodyClass="bodyClass">
                                    <template #body="slotProps">
                                        <h5>{{ slotProps.data.type_description }}</h5>
                                    </template>
                                </Column>
                                <Column :header="$t('AppApontamentos.Ações')" headerClass="headerClass"
                                        bodyClass="bodyClass">
                                    <template #body="slotProps">
                                        <div>
                                            <Button icon="pi pi-times" class="p-button-rounded delete-btn"
                                                    @click='openDialog("delete",slotProps.data)'/>
                                        </div>
                                    </template>
                                </Column>

                            </DataTable>
                        </div>
                        <div v-else>
                            <h4>{{ $t('AppApontamentos.Nenhum apontamento registrado para a organização') }}.</h4>
                        </div>
                    </div>

                    <div class="apontamentos-add">
                        <app-button type="primary" @handleClick='openDialog("add")'>
                            <span class="pi pi-plus mr-2"/>
                            {{ $t('AppApontamentos.Adicionar Apontamento') }}
                        </app-button>
                    </div>
                </div>

                <!------------------------ DIALOG: ADD STOP REASONS --------------------------------->
                <Dialog :header="$t('AppApontamentos.Adicionar Apontamento')" :visible="displayAddApontamentos"
                        :modal="true"
                        @update:visible='closeDialog("add")'>
                    <div class="dialog-body_add" :style="{'width': widthDialog}">
                        <div>
                            <p>{{ $t('AppApontamentos.Código') }}: </p>
                            <app-input type="text" :placeholder="$t('AppApontamentos.Exemplo') + ': AB12C'"
                                       @keydown.native="removeComma($event)"
                                       v-model="newApontamento.code"></app-input>
                        </div>
                        <div class="mt-3">
                            <p>{{ $t('AppApontamentos.Descrição') }}: </p>
                            <app-input type="text"
                                       :placeholder="$t('AppApontamentos.Exemplos almoço, abastecimento, banheiro, etc')"
                                       @keydown.native="removeComma($event)"
                                       v-model="newApontamento.description"></app-input>
                        </div>
                        <div class="mt-3">
                            <p>{{ $t('AppApontamentos.Tipo de parada') }}: </p>
                            <Dropdown style="width: 100%"
                                      :placeholder="$t('AppApontamentos.Selecione o tipo de apontamento')"
                                      v-model="newApontamento.type" appendTo="body"
                                      :options="stopTypesList" optionLabel="description" class="auto-center"></Dropdown>
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="$t('AppApontamentos.Cancelar')" icon="pi pi-times" @click='closeDialog("add")'
                                class="p-button-text"/>
                        <Button :disabled="disableButton" :label="$t('AppApontamentos.Adicionar')" icon="pi pi-check"
                                @click="addApontamentos()"/>
                    </template>
                </Dialog>

                <!------------------------ DIALOG: DELETE STOP REASONS --------------------------------->
                <Dialog :header="$t('AppApontamentos.Deletar Apontamentos')" :visible="displayDeleteApontamentos"
                        :modal="true"
                        @update:visible='closeDialog("delete")'>
                    <div class="dialog-body">
                        <h5>{{ $t('AppApontamentos.Deseja deletar o apontamento') }}:</h5>
                        <div
                            style="display: flex; justify-content:center; min-width: 300px; max-width: 800px;margin-top:1.5rem">
                            <h3>{{ deleteApontamento.code }}: {{ deleteApontamento.description }}
                                ({{ deleteApontamento.type_description }}) ?</h3>
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="$t('AppApontamentos.Cancelar')" icon="pi pi-times" class="p-button-text"
                                @click='closeDialog("delete")'/>
                        <Button :disabled="disableButton" :label="$t('AppApontamentos.Deletar')" icon="pi pi-check"
                                @click="deleteApontamentos()"/>
                    </template>
                </Dialog>

                <!------------------------ DIALOG: IMPORT ACTIVITIES --------------------------------->
                <Dialog :label="$t('AppApontamentos.Importar Apontamento')" :visible="displayImportApontamentos" :modal="true"
                        @update:visible='closeDialog("import")'>
                    <div v-if="!importSelected" style="max-height: 50vh" :style="{'width': widthDialog}">
                        <p>{{$t('AppApontamentos.De qual organização você deseja importar')}}</p>
                        <Listbox v-model="organizationImportSelected" :options="orgsList"
                                 optionLabel="display_name"
                                 :dataKey="'id'"
                                 :filter="true"
                                 :filterPlaceholder="$t('AppApontamentos.Procure pelo nome da organização')"
                                 class="existent-list">
                        </Listbox>
                    </div>
                    <div v-else style="max-height: 50vh" :style="{'width': widthDialog}">
                        <p>{{ $t('AppApontamentos.Selecione os apontamentos que deseja importar') }}:</p>
                        <DataTable :value="importedApontamentos" :rowHover="true"
                                   :selection.sync="selectedImportedApontamentos" dataKey="id" responsiveLayout="scroll"
                                   :loading="importedApontamentosLoading" class="p-datatable-striped">
                            <template #loading>
                                {{ $t('AppApontamentos.Importar Carregando apontamentos, por favor aguarde') }}
                            </template>
                            <Column selectionMode="multiple" headerStyle="width: 3rem" headerClass="headerClass"
                                    bodyClass="bodyClass"></Column>
                            <Column field="code" :header="$t('AppApontamentos.Código')" headerClass="headerClass"
                                    bodyClass="bodyClass"></Column>
                            <Column field="description" :header="$t('AppApontamentos.Descrição')"
                                    headerClass="headerClass"
                                    bodyClass="bodyClass"></Column>
                            <Column field="type_description" :header="$t('AppApontamentos.Tipo de Parada')"
                                    headerClass="headerClass"
                                    bodyClass="bodyClass"></Column>
                        </DataTable>
                    </div>
                    <template #footer>
                        <div style="padding-top: 1rem">
                            <Button :label="$t('AppApontamentos.Cancelar')" icon="pi pi-times" class="p-button-text"
                                    style="border: 1px solid #2196f3"
                                    @click='closeDialog("import")'/>
                            <Button v-if="!importSelected" :label="$t('AppApontamentos.Prosseguir')"
                                    icon="pi pi-angle-right"
                                    @click="importNextPage()"/>
                            <Button :disabled="disableButton" v-else :label="$t('AppApontamentos.Salvar')"
                                    icon="pi pi-check"
                                    @click="importApontamentos()"/>
                        </div>
                    </template>
                </Dialog>

            </div>
        </div>
    </div>
</template>

<script>
import {router} from '../../../router';
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import Button from "primevue/button";
import Dropdown from 'primevue/dropdown';
import DataTable from 'primevue/datatable';
import Listbox from 'primevue/listbox';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import OrganizationsService from "../../../services/OrganizationsService";
import ApontamentosService from "../../../services/ApontamentosService";
import {stopReasonsTypes} from "./stopReasonsList";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";

export default {
    mixins: [orderCustomFieldByNaturalOrder],
    beforeMount() {
        this.organizationsService = new OrganizationsService();
        this.apontamentosService = new ApontamentosService();
        this.getOrganizations();
    },
    mounted() {
        this.widthDialog = this.isScreenMobile ? '85vw' : '30vw';
        this.is_col_12 = this.isScreenMobile;
    },
    data() {
        return {
            is_col_12: false,
            widthDialog: '',
            stopTypesList: stopReasonsTypes,
            disableButton: false,
            //organizations
            organizationsService: null,
            organizationSelected: null,
            organizationImportSelected: null,
            orgsList: null,
            loadingOrgs: true,
            //stop reasons
            apontamentosService: null,
            apontamentosLoading: false,
            importedApontamentosLoading: false,
            importedApontamentos: null,
            selectedImportedApontamentos: null,
            newApontamento: {"code": '', "description": '', "type": ''},
            deleteApontamento: {"code": '', "description": '', "type": ''},
            //dialogos
            displayAddApontamentos: false,
            displayDeleteApontamentos: false,
            displayImportApontamentos: false,
            importSelected: false,
            //resposta para o backend
            apontamentosList: [],
            storedChosenOptions: null
        }
    },
    methods: {
        back() {
            router.push('/settings');
        },
        removeComma(e) {
            if (/,/g.test(e.key)) {
                e.preventDefault();
            }
        },
        //Carrega todas as organizaçãoes que o usuário tem acesso no ínicio da sessão = beforeMount()
        getOrganizations() {
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('APPCONFIGS').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
                console.log(error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.orgsList = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.organizationSelected = this.storedChosenOptions['clients'].filter(a => this.orgsList.some(b => a.id === b.id))[0];

            if (this.organizationSelected) {
                this.handleOrganizationChange(this.organizationSelected);
            }
        },
        //Carrega a lista de apontamentos organização selecionada ao alterar o dropdown e ao fazer qualquer alteração (adicionar, deletar, editar e importar).
        handleOrganizationChange(organization) {
            this.apontamentosLoading = true;
            this.apontamentosList = [];
            this.apontamentosService.getApontamentosByOrganization(organization.id)
                .then((response) => {
                    this.apontamentosList = response;
                    if (this.apontamentosList) {
                        this.getStopTypes(this.apontamentosList);
                    }
                }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                this.apontamentosLoading = false;
            })

            this.saveChosenOptionsToLocalStorage();
        },
        saveChosenOptionsToLocalStorage() {
            if (!this.storedChosenOptions) {
                this.storedChosenOptions = {}
            }

            this.storedChosenOptions['clients'] = [this.organizationSelected];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getStopTypes(stop_reasons) {
            for (let i = 0; i < stop_reasons.length; i++) {
                let type = this.stopTypesList.find(stop => stop.type === stop_reasons[i].type);
                stop_reasons[i].type_description = type.description;
            }
        },
        //Abre a caixa de diálogo referente ao botão clicado
        openDialog(str, stop_reason) {
            if (str === "add") {
                this.displayAddApontamentos = true;
            } else if (str === "delete") {
                this.deleteApontamento = JSON.parse(JSON.stringify(stop_reason));
                this.displayDeleteApontamentos = true;
            } else if (str === "import") {
                this.displayImportApontamentos = true;
            }
        },
        //Fecha a caixa de diálogo aberta
        closeDialog(str) {
            if (str === "add") {
                this.displayAddApontamentos = false;
                this.newApontamento = {"code": '', "description": '', "type": ''};
            } else if (str === "delete") {
                this.deleteApontamento = '';
                this.displayDeleteApontamentos = false;
            } else if (str === "import") {
                this.displayImportApontamentos = false;
                this.importSelected = false;
                this.importedApontamentos = null;
                this.organizationImportSelected = null;
                this.selectedImportedApontamentos = null
            }
        },
        //verifica se já existe o apontamento vinculada a organização ao adicionar ou editar
        checkApontamentos(stop_reason) {
            let answer = true;
            let stop_reasons_list = this.apontamentosList;

            if (stop_reason.code === '' || stop_reason.description === '' || stop_reason.type === '') {
                return false;
            } else if (stop_reasons_list !== null) {
                for (let i = 0; i < stop_reasons_list.length; i++) {
                    if (stop_reason.code.toUpperCase() === stop_reasons_list[i].code.toUpperCase() ||
                        stop_reason.description.toUpperCase() === stop_reasons_list[i].description.toUpperCase()) {
                        return false;
                    }
                }
            }
            stop_reason.type = stop_reason.type.type;
            return answer;
        },
        //adicionar um novo apontamento
        addApontamentos() {
            this.disableButton = true;
            if (this.checkApontamentos(this.newApontamento)) {
                this.apontamentosService.addApontamentos(this.organizationSelected.id, [this.newApontamento])
                    .then((response) => {
                        this.$toast.add({
                            severity: 'success',
                            summary: this.$t('AppApontamentos.Sucesso'),
                            detail: this.$t('AppApontamentos.Apontamento cadastrado'),
                            life: 5000
                        });
                    }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                }).finally(() => {
                    this.disableButton = false;
                    this.displayAddApontamentos = false;
                    this.newApontamento = {"code": '', "description": '', "type": ''};
                    this.handleOrganizationChange(this.organizationSelected);
                })
            } else {
                if (this.newApontamento.code === '' || this.newApontamento.description === '' || this.newApontamento.type === '') {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Erro'),
                        detail: this.$t('AppApontamentos.Preencha todos os campos'),
                        life: 5000
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Erro'),
                        detail: this.$t('AppApontamentos.Código ou Descrição já existentes!'),
                        life: 5000
                    });
                }
                this.disableButton = false;
            }
        },
        //deletar um apontamento
        deleteApontamentos() {
            this.disableButton = true;
            this.apontamentosService.deleteApontamentos(this.deleteApontamento.id)
                .then((response) => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppApontamentos.Sucesso'),
                        detail: this.$t('AppApontamentos.Apontamento deletado'),
                        life: 5000
                    });
                }).catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 409) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Erro'),
                        detail: this.$t('AppApontamentos.Não foi possível deletar o apontamento, pois está presente em uma lista de configuração'),
                        life: 5000
                    });
                    return
                }
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }

                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                this.disableButton = false;
                this.displayDeleteApontamentos = false;
                this.deleteApontamento = '';
                this.handleOrganizationChange(this.organizationSelected);
            })
        },
        //verificação da edição de apontamento
        checkApontamentosEdit(stop_reason) {
            let edited_reason = this.apontamentosList.filter(list => list.id === stop_reason.id);
            let stop_reasons_list = this.apontamentosList.filter(list => list.id !== stop_reason.id);
            if ((stop_reason.code === edited_reason[0].code && stop_reason.description === edited_reason[0].description
                && stop_reason.type.type === edited_reason[0].type) || (stop_reason.code === '' || stop_reason.description === '')) {
                return false;
            } else if (stop_reasons_list !== null) {
                for (let i = 0; i < stop_reasons_list.length; i++) {
                    if (stop_reason.code.toUpperCase() === stop_reasons_list[i].code.toUpperCase() ||
                        stop_reason.description.toUpperCase() === stop_reasons_list[i].description.toUpperCase()) {
                        return false;
                    }
                }
            }
            return true;
        },
        //função para seguir para próxima página na caixa de diálogo de importar apontamento
        importNextPage() {
            if (this.organizationImportSelected === null) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Erro'),
                    detail: this.$t('Selecione uma organização'),
                    life: 5000
                });
            } else {
                this.importSelected = true;
                this.importedApontamentosLoading = true;
                this.getImportedOrgApontamentos();
            }
        },
        //a função solicita ao backend a lista de apontamentos da organização selecionada para importar
        getImportedOrgApontamentos() {
            this.apontamentosService.getApontamentosByOrganization(this.organizationImportSelected.id)
                .then((response) => {
                    this.importedApontamentos = response;
                    this.getStopTypes(this.importedApontamentos);
                }).catch((error) => {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                this.importedApontamentosLoading = false;
                if (!this.importedApontamentos) {
                    this.importSelected = false;
                }
            })
        },
        //verifica se a organização já possui o apontamento (por código ou descrição) que o usuário está tentando importar
        checkImportedApontamentos(stop_reasons) {
            let stop_reasons_org = this.apontamentosList;
            if (stop_reasons_org !== null) {
                for (let i = 0; i < stop_reasons.length; i++) {
                    let equal_code = stop_reasons_org.find(item => item.code.toUpperCase() === stop_reasons[i].code.toUpperCase());
                    let equal_description = stop_reasons_org.find(item => item.description.toUpperCase() === stop_reasons[i].description.toUpperCase());
                    if (equal_code || equal_description) {
                        return false
                    }
                }
            }
            return true;
        },
        //realiza a importação dos apontamentos
        importApontamentos() {
            this.disableButton = true;
            //Retorna erro se o usuário não selecionar nenhum apontamento
            if (this.selectedImportedApontamentos === null || this.selectedImportedApontamentos.length === 0) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Erro'),
                    detail: this.$t('AppApontamentos.Selecione um apontamento'),
                    life: 5000
                });
                this.disableButton = false;
                return;
            }


            console.log(this.selectedImportedApontamentos)
            if (this.checkImportedApontamentos(this.selectedImportedApontamentos)) {
                this.apontamentosService.addApontamentos(this.organizationSelected.id, this.selectedImportedApontamentos)
                    .then((response) => {
                        this.$toast.add({
                            severity: 'success',
                            summary: this.$t('AppApontamentos.Sucesso'),
                            detail: this.$t('AppApontamentos.Apontamentos cadastrados'),
                            life: 5000
                        });
                    }).catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppApontamentos.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppApontamentos.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                }).finally(() => {
                    this.disableButton = false;
                    this.displayImportApontamentos = false;
                    this.importedApontamentos = null;
                    this.importSelected = false;
                    this.handleOrganizationChange(this.organizationSelected);
                    this.selectedImportedApontamentos = null
                    this.organizationImportSelected = null;
                })
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppApontamentos.Erro'),
                    detail: this.$t('AppApontamentos.Você já possui um dos apontamentos selecionados'),
                    life: 5000
                });
                this.disableButton = false;
            }


        },
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    },
    components: {
        AppButton,
        AppInput,
        Button,
        Dropdown,
        DataTable,
        Listbox,
        Column,
        Dialog,
        OrganizationsService,
        ApontamentosService,
        stopReasonsTypes
    }
}

</script>

<style scoped lang="scss">

@import "src/assets/styles/constants";


.apontamentos-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
}

.white-background {
    background: white;
    padding: 1rem 2rem 1rem 2rem;
    border-radius: 5px;
    margin: 0rem;
}

.apontamentos-list {
    width: 50%;
    display: flex;
    flex-direction: column;
}

.apontamentos-list_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.apontamentos-list_table {
    display: flex;
    justify-content: center;
    margin: 2rem 0rem 2rem 0rem;
}

.apontamentos-add {
    display: flex;
    justify-content: center;
}

.dialog-body_add {
    justify-content: space-between;
}

.delete-btn {
    border: none;
    background-color: #E51111;
}

.delete-btn:enabled:hover {
    background-color: #AD1111;
}

.width-button {
    max-width: 55px;
    margin: 5px;
}

@media(max-width: 1024px) {
    .apontamentos-list {
        width: 95%;
        margin: 0rem 2rem 0rem 2rem;
    }

    .margin-25-right {
        margin: 0px !important;
    }

    .dropdown-width {
        width: 250px;
    }
}


</style>
